export default __webpack_public_path__ + "static/familie-leker-ddcc1a0dacd2f6bafba6a9abb10e901c.jpg";